import FadeSwiper from "./index.vue"

export default FadeSwiper